// Katastr nemovitostí
<template>
  <v-container fluid v-resize="onResize">
    <v-app-bar rounded="lg" absolute class="ma-1" dense style="z-index: 2" color="colorKn">
      <v-app-bar-title class="">Katastr nemovitostí</v-app-bar-title>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="Dialog_NajdiKn_view = true" class="ml-12">
            <v-icon>mdi-text-box-search</v-icon>
          </v-btn>
        </template>
        <span>Hledání v katastru nemovitostí</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-btn-toggle borderless active-class="info" background-color="transparent" v-model="KnVybTyp">

        <!-- Parcela -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" value="KnPar" v-show="VybKnPar.Id">
              <v-icon>mdi-card</v-icon>
            </v-btn>
          </template>
          <span>Informace o parcele</span>
        </v-tooltip>

        <!-- Stavba -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" value="KnSta" v-show="VybKnSta.Id">
              <v-icon>mdi-home</v-icon>
            </v-btn>
          </template>
          <span>Informace o stavbě</span>
        </v-tooltip>

        <!-- Právo stavby -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" value="KnPra" v-show="VybKnPra.Id">
              <v-icon>mdi-toy-brick</v-icon>
            </v-btn>
          </template>
          <span>Informace o právu stavby</span>
        </v-tooltip>

        <!-- Jednotka -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" value="KnJed" v-show="VybKnJed.Id">
              <v-icon>mdi-door</v-icon>
            </v-btn>
          </template>
          <span>Informace o jednotce</span>
        </v-tooltip>

        <!-- List vlastnictví -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" value="KnLv" v-show="VybKnLv.Id || VybKnLv.Ident.cisloLv">
              <v-icon>mdi-text-box</v-icon>
            </v-btn>
          </template>
          <span>List vlastnictví</span>
        </v-tooltip>

        <!-- Přehled vlastnictví -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" value="KnOs" v-show="VybKnOs.Id">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <span>Přehled vlastnictví</span>
        </v-tooltip>

        <!-- řízení -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" value="KnRiz" v-show="VybKnRiz.Id">
              <v-icon>mdi-clipboard-text</v-icon>
            </v-btn>
          </template>
          <span>Informace o řízení</span>
        </v-tooltip>

      </v-btn-toggle>

      <v-spacer></v-spacer>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-card v-bind="attrs" v-on="on" class="mx-1" color="transparent" flat width="200" v-if="true">
            <v-slider v-model="VypisZoom" class="align-center" max="120" min="50" step="1" thumb-color="accent2"
              hide-details dense>
              <template v-slot:append>
                <div v-text="VypisZoom + ' %'" class="text-no-wrap text-right mr-2" style="width: 40px"></div>
              </template>
            </v-slider>
          </v-card>
        </template>
        <span>Měřítko výpisu</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="VypisLight = !VypisLight" class="ml-1">
            <v-icon v-if="VypisLight" color="">mdi-sticker-text</v-icon>
            <v-icon v-else color="">mdi-sticker-text-outline</v-icon>
          </v-btn>
        </template>
        <span>Inverzní výpis</span>
      </v-tooltip>

      <v-btn icon @click="VybCompClose()" class="ml-8">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>




    <!-- Výpis parcely -->
    <v-app-bar rounded="lg" absolute class="ma-1 mt-14" dense extension-height="auto" color="colorKn"
      v-if="KnVybTyp == 'KnPar'">
      <v-icon class="mr-3" color="info">mdi-card</v-icon>

      <v-app-bar-title class="text-body-1">Informace o parcele</v-app-bar-title>

      <v-spacer></v-spacer>

      <!-- List vlastnictví -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" value="KnLv" v-if="true" @click="VybKnPar_ZobrazLv()">
            <v-icon>mdi-text-box</v-icon>
          </v-btn>
        </template>
        <span>List vlastnictví vybrané parcely</span>
      </v-tooltip>

      <!-- Stavba -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" value="KnSta"
            v-if="VybKnPar.Info && VybKnPar.Info.stavba && VybKnPar.Info.stavba.idStavby"
            @click="ZmenaVybKn('KnSta', VybKnPar.Info.stavba.idStavby)">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
        <span>Informace o stavbě na vybrané parcele</span>
      </v-tooltip>

      <!-- Právo stavby -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" value="KnPra"
            v-if="VybKnPar.Info && VybKnPar.Info.pravoStavby && VybKnPar.Info.pravoStavby.idPravoStavby"
            @click="ZmenaVybKn('KnPra', VybKnPar.Info.pravoStavby.idPravoStavby)">
            <v-icon>mdi-toy-brick</v-icon>
          </v-btn>
        </template>
        <span>Informace o právu stavby na vybrané parcele</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Zoom na mapě -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="VybKnPar_MapZoom()" class="ml-7">
            <v-icon>mdi-map-marker</v-icon>
          </v-btn>
        </template>
        <span>Zobrazit na mapě</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-card rounded="lg" class="mt-1 pa-2 overflow-auto" style="resize: both" :max-height="VypisHeight"
          min-width="250" v-show="VybKnPar.Vypis">
          <v-card class="px-4" :light="VypisLight">
            <div v-html="VybKnPar.Vypis" :style="{
                transform: 'scale(' + VypisZoom / 100 + ')',
                transformOrigin: 'top left',
              }"></div>
          </v-card>
        </v-card>
      </template>
    </v-app-bar>


    <!-- Výpis stavby -->
    <v-app-bar rounded="lg" absolute class="ma-1 mt-14" dense extension-height="auto" color="colorKn"
      v-if="KnVybTyp == 'KnSta'">
      <v-icon class="mr-3" color="info">mdi-home</v-icon>

      <v-app-bar-title class="text-body-1">Informace o stavbě</v-app-bar-title>

      <v-spacer></v-spacer>

      <!-- List vlastnictví -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" value="KnLv" v-if="true" @click="VybKnSta_ZobrazLv()">
            <v-icon>mdi-text-box</v-icon>
          </v-btn>
        </template>
        <span>List vlastnictví vybrané stavby</span>
      </v-tooltip>

      <!-- parcela -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" value="KnSta"
            v-if="VybKnSta.Info && VybKnSta.Info.parcelaIdentifikacni && VybKnSta.Info.parcelaIdentifikacni.idParcely"
            @click="ZmenaVybKn('KnPar', VybKnSta.Info.parcelaIdentifikacni.idParcely)">
            <v-icon>mdi-card</v-icon>
          </v-btn>
        </template>
        <span>Informace o parcele vybrané stavby</span>
      </v-tooltip>

      <!-- Právo stavby -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" value="KnPra"
            v-if="VybKnSta.Info && VybKnSta.Info.pravoStavby && VybKnSta.Info.pravoStavby.idPravoStavby"
            @click="ZmenaVybKn('KnPra', VybKnSta.Info.pravoStavby.idPravoStavby)">
            <v-icon>mdi-toy-brick</v-icon>
          </v-btn>
        </template>
        <span>Informace o právu stavby vybrané stavby</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-card rounded="lg" class="mt-1 pa-2 overflow-auto" style="resize: both" :max-height="VypisHeight"
          min-width="250" v-show="VybKnSta.Vypis">
          <v-card class="px-4" :light="VypisLight">
            <div v-html="VybKnSta.Vypis" :style="{
                transform: 'scale(' + VypisZoom / 100 + ')',
                transformOrigin: 'top left',
              }"></div>
          </v-card>
        </v-card>
      </template>
    </v-app-bar>


    <!-- Výpis práva stavby -->
    <v-app-bar rounded="lg" absolute class="ma-1 mt-14" dense extension-height="auto" color="colorKn"
      v-if="KnVybTyp == 'KnPra'">
      <v-icon class="mr-3" color="info">mdi-toy-brick</v-icon>

      <v-app-bar-title class="text-body-1">Informace o právu stavby</v-app-bar-title>

      <v-spacer></v-spacer>

      <!-- List vlastnictví -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" value="KnLv" v-if="true" @click="VybKnPra_ZobrazLv()">
            <v-icon>mdi-text-box</v-icon>
          </v-btn>
        </template>
        <span>List vlastnictví vybraného práva stavby</span>
      </v-tooltip>


      <!-- dpolnit sem dotčené parcely z infa  -->

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-card rounded="lg" class="mt-1 pa-2 overflow-auto" style="resize: both" :max-height="VypisHeight"
          min-width="250" v-show="VybKnPra.Vypis">
          <v-card class="px-4" :light="VypisLight">
            <div v-html="VybKnPra.Vypis" :style="{
                transform: 'scale(' + VypisZoom / 100 + ')',
                transformOrigin: 'top left',
              }"></div>
          </v-card>
        </v-card>
      </template>
    </v-app-bar>


    <!-- Výpis jednotky -->
    <v-app-bar rounded="lg" absolute class="ma-1 mt-14" dense extension-height="auto" color="colorKn"
      v-if="KnVybTyp == 'KnJed'">
      <v-icon class="mr-3" color="info">mdi-door</v-icon>

      <v-app-bar-title class="text-body-1">Informace o jednotce</v-app-bar-title>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-card rounded="lg" class="mt-1 pa-2 overflow-auto" style="resize: both" :max-height="VypisHeight"
          min-width="250" v-show="VybKnJed.Vypis">
          <v-card class="px-4" :light="VypisLight">
            <div v-html="VybKnJed.Vypis" :style="{
                transform: 'scale(' + VypisZoom / 100 + ')',
                transformOrigin: 'top left',
              }"></div>
          </v-card>
        </v-card>
      </template>
    </v-app-bar>


    <!-- Výpis List vlastnictví -->
    <v-app-bar rounded="lg" absolute class="ma-1 mt-14" dense extension-height="auto" color="colorKn"
      v-if="KnVybTyp == 'KnLv'">
      <v-icon class="mr-3" color="info">mdi-text-box</v-icon>

      <v-app-bar-title class="text-body-1">List vlastnictví</v-app-bar-title>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-card rounded="lg" class="mt-1 pa-2 overflow-auto" style="resize: both" :max-height="VypisHeight"
          min-width="250" v-show="VybKnLv.Vypis">
          <v-card class="px-4" :light="VypisLight">
            <div v-html="VybKnLv.Vypis" :style="{
                transform: 'scale(' + VypisZoom / 100 + ')',
                transformOrigin: 'top left',
              }"></div>
          </v-card>
        </v-card>
      </template>
    </v-app-bar>


    <!-- Výpis Přehledu vlastnictví -->
    <v-app-bar rounded="lg" absolute class="ma-1 mt-14" dense extension-height="auto" color="colorKn"
      v-if="KnVybTyp == 'KnOs'">
      <v-icon class="mr-3" color="info">mdi-account</v-icon>

      <v-app-bar-title class="text-body-1">Přehled vlastnictví</v-app-bar-title>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-card rounded="lg" class="mt-1 pa-2 overflow-auto" style="resize: both" :max-height="VypisHeight"
          min-width="250" v-show="VybKnOs.Vypis">
          <v-card class="px-4" :light="VypisLight">
            <div v-html="VybKnOs.Vypis" :style="{
                transform: 'scale(' + VypisZoom / 100 + ')',
                transformOrigin: 'top left',
              }"></div>
          </v-card>
        </v-card>
      </template>
    </v-app-bar>


    <!-- Výpis řízení -->
    <v-app-bar rounded="lg" absolute class="ma-1 mt-14" dense extension-height="auto" color="colorKn"
      v-if="KnVybTyp == 'KnRiz'">
      <v-icon class="mr-3" color="info">mdi-clipboard-text</v-icon>

      <v-app-bar-title class="text-body-1">Informace o řízení</v-app-bar-title>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-card rounded="lg" class="mt-1 pa-2 overflow-auto" style="resize: both" :max-height="VypisHeight"
          min-width="250" v-show="VybKnRiz.Vypis">
          <v-card class="px-4" :light="VypisLight">
            <div v-html="VybKnRiz.Vypis" :style="{
                transform: 'scale(' + VypisZoom / 100 + ')',
                transformOrigin: 'top left',
              }"></div>
          </v-card>
        </v-card>
      </template>
    </v-app-bar>





    <!-- Hledat v katastru -->
    <v-dialog v-model="Dialog_NajdiKn_view" max-width="600">
      <v-card :loading="IsLoading_KnNajdi" min-height="394">
        <v-card-title class="colorKn">
          <div>Hledat v katastru nemovitostí</div>

          <v-spacer></v-spacer>

          <v-btn icon @click="Dialog_NajdiKn_view = false" class="">
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </v-card-title>

        <v-container class="pa-1">
          <!-- výběr typu -->
          <v-row dense justify="center" class="">
            <v-col cols="auto">
              <v-btn-toggle mandatory borderless active-class="info" v-model="KnNajdiTyp">

                <!-- Parcela -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" value="KnPar">
                      <v-icon>mdi-card</v-icon>
                    </v-btn>
                  </template>
                  <span>Vyhledání parcely</span>
                </v-tooltip>

                <!-- Stavba -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" value="KnSta">
                      <v-icon>mdi-home</v-icon>
                    </v-btn>
                  </template>
                  <span>Vyhledání stavby</span>
                </v-tooltip>

                <!-- Právo stavby -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" value="KnPra">
                      <v-icon>mdi-toy-brick</v-icon>
                    </v-btn>
                  </template>
                  <span>Vyhledání práva stavby</span>
                </v-tooltip>

                <!-- Jednotka -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" value="KnJed" v-if="false">
                      <v-icon>mdi-door</v-icon>
                    </v-btn>
                  </template>
                  <span>Vyhledání jednotky</span>
                </v-tooltip>

                <!-- List vlastnictví -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" value="KnLv">
                      <v-icon>mdi-text-box</v-icon>
                    </v-btn>
                  </template>
                  <span>Vyhledání listu vlastnictví</span>
                </v-tooltip>

                <!-- Přehled vlastnictví -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" value="KnOs" v-if="false">
                      <v-icon>mdi-account</v-icon>
                    </v-btn>
                  </template>
                  <span>Vyhledání vlastnictví</span>
                </v-tooltip>

                <!-- řízení -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" value="KnRiz" v-if="false">
                      <v-icon>mdi-clipboard-text</v-icon>
                    </v-btn>
                  </template>
                  <span>Vyhledání řízení</span>
                </v-tooltip>

              </v-btn-toggle>

            </v-col>
          </v-row>
          <!-- výběr obce -->
          <v-row v-if="true" dense justify="center" class="mt-4">
            <v-col cols="auto">
              <v-card flat width="400" class="">
                <v-autocomplete label="Obec (nepovinné)" color="colorKn" clearable filled dense v-model="VybObec"
                  :items="KnSeznam.KnSeznamObci" :filter="FiltrSeznamObec" hide-details="true" class="mx-1">
                  <template v-slot:item="{ item }">
                    {{ item.kod }} - {{ item.nazev }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.kod }} - {{ item.nazev }}
                  </template>
                </v-autocomplete>
              </v-card>
            </v-col>
          </v-row>
          <!-- výběr ku -->
          <v-row v-if="KnNajdiTyp == 'KnPar' || KnNajdiTyp == 'KnLv' || KnNajdiTyp == 'KnPra'" dense justify="center"
            class="">
            <v-col cols="auto">
              <v-card flat width="400" class="">
                <v-autocomplete label="Katastrální území" color="colorKn" clearable filled dense v-model="VybKu"
                  :items="KnSeznamKnSeznamKUObec" :filter="FiltrSeznamKu" hide-details="true" class="mx-1">
                  <template v-slot:item="{ item }">
                    {{ item.kod }} - {{ item.nazev }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.kod }} - {{ item.nazev }}
                  </template>
                </v-autocomplete>
              </v-card>
            </v-col>
          </v-row>
          <!-- výběr části obce -->
          <v-row v-if="KnNajdiTyp == 'KnSta' || KnNajdiTyp == 'KnJed'" dense justify="center" class="">
            <v-col cols="auto">
              <v-card flat width="400" class="">
                <v-autocomplete label="Část obce" color="colorKn" clearable filled dense v-model="VybCastObce"
                  :items="KnSeznamKnSeznamCastiObciObec" :filter="FiltrSeznamCastiObci" hide-details="true" class="mx-1">
                  <template v-slot:item="{ item }">
                    {{ item.kod }} - {{ item.nazev }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.kod }} - {{ item.nazev }}
                  </template>
                </v-autocomplete>
              </v-card>
            </v-col>
          </v-row>


          <!-- výběr parcely a práva stavby -->
          <v-row v-if="KnNajdiTyp == 'KnPar' || KnNajdiTyp == 'KnPra'" dense justify="center" class="mt-4">
            <v-col cols="auto" align-self="end" class="mb-3">
              <span class="ma-2 mr-2 text-subtitle-1 ">{{
                (KnNajdiTyp == 'KnPar') ? 'Parcela:' : 'Právo stavby na parcele:' }} </span>
            </v-col>
            <v-col cols="auto">
              <v-card flat width="100" class="mt-2 mx-1">
                <v-text-field label="Číslo" v-model="NajdiParCis" hide-details="true" class=""></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="auto">
              <v-card flat width="90" class="mt-2 mx-1">
                <v-text-field label="Podlomení" v-model="NajdiParPod" hide-details="true" class=""></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="auto" v-if="KnNajdiTyp == 'KnPar'">
              <v-btn @click="NajdiPar" color="colorKn" class="ma-3">
                <v-icon>mdi-text-box-search</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="auto" v-if="KnNajdiTyp == 'KnPra'">
              <v-btn @click="NajdiPra" color="colorKn" class="ma-3">
                <v-icon>mdi-text-box-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <!-- výběr stavby -->
          <v-row v-if="KnNajdiTyp == 'KnSta'" dense justify="center" class="mt-4">
            <v-col cols="auto" align-self="end" class="mb-3">
              <span class="ma-2 mr-2 text-subtitle-1 ">Stavba:</span>
            </v-col>
            <v-col cols="auto">
              <v-card flat width="294" class="mt-3 mx-1">
                <v-select mandatory color="colorKn" filled dense v-model="NajdiStaTyp"
                  :items="KnSeznam.KnSeznamTypuStaveb" hide-details="true" class="">
                  <template v-slot:item="{ item }">
                    {{ item.nazev }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.nazev }}
                  </template>
                </v-select>
              </v-card>
            </v-col>
            <v-col cols="auto">
              <v-card flat width="100" class="mt-2 mx-1">
                <v-text-field label="Číslo" v-model="NajdiStaCis" hide-details="true" class=""></v-text-field>
              </v-card>
            </v-col>

            <v-col cols="auto">
              <v-btn @click="NajdiSta" color="colorKn" class="ma-3">
                <v-icon>mdi-text-box-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <!-- výběr lv -->
          <v-row v-if="KnNajdiTyp == 'KnLv'" dense justify="center" class="mt-4">
            <v-col cols="auto" align-self="end" class="mb-3">
              <span class="ma-2 mr-2 text-subtitle-1 ">Číslo Lv:</span>
            </v-col>
            <v-col cols="auto">
              <v-card flat width="100" class="mt-2 mx-1">
                <v-text-field label="Číslo" v-model="NajdiLvCis" hide-details="true" class=""></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="NajdiLv" color="colorKn" class="ma-3">
                <v-icon>mdi-text-box-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <!-- Nalezené parcely -->
          <v-row v-if="KnNajdiTyp == 'KnPar'" dense>
            <v-col cols="auto">
              <v-card flat class="mt-2 overflow-y-auto align-content-center d-flex" width="592" min-height="48"
                color="info">
                <table class="KnTableNalez">

                  <tbody v-for="item in NalPars" :key="item.idParcely">

                    <tr>
                      <td rowspan="2">
                        <span class="success--text text-h6 font-weight-black">
                          {{
                            item.kmenoveCislo +
                            (item.poddeleniCisla
                              ? "/" + item.poddeleniCisla
                              : "") +
                            (item.dil ? " díl " + item.dil : "")
                          }}
                        </span>
                      </td>
                      <td rowspan="2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="">{{ item.vymera + ' m'
                            }}<sup>2</sup></span>
                          </template>
                          <span>Výměra</span>
                        </v-tooltip>
                      </td>

                      <td rowspan="2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.idParcely" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnPar', item.idParcely, null, item)">
                              <v-icon>mdi-card</v-icon>
                            </v-btn>
                          </template>
                          <span>Informace o parcele</span>
                        </v-tooltip>
                      </td>
                      <td rowspan="2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.lvId" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnLv', item.lvId)">
                              <v-icon>mdi-text-box</v-icon>
                            </v-btn>
                          </template>
                          <span>List vlastnictví</span>
                        </v-tooltip>
                      </td>
                      <td rowspan="2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.stavba" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnSta', item.stavba.idStavby)">
                              <v-icon>mdi-home</v-icon>
                            </v-btn>
                          </template>
                          <span>Informace o stavbě na parcele</span>
                        </v-tooltip>
                      </td>
                      <td rowspan="2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.pravoStavby" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnPra', item.pravoStavby.idPravoStavby)">
                              <v-icon>mdi-toy-brick</v-icon>
                            </v-btn>
                          </template>
                          <span>Informace o právu stavby na parcele</span>
                        </v-tooltip>
                      </td>

                      <td rowspan="2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{ item.parcelaTypePopis }}</span>
                          </template>
                          <span>Typ parcely</span>
                        </v-tooltip>
                      </td>

                      <td>
                        <span class="font-italic">{{ (KnSeznam.KnSeznamCislovaniParcel.find(itemc => ('Item' + itemc.kod)
                          ==
                          item.druhCislovaniParPopis)).nazev }}</span>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span class="font-italic" v-bind="attrs" v-on="on"> {{ item.typZE ?
                              KnSeznam.KnSeznamZdrojuCislovaniZE.find(itemc =>
                                itemc.kod ==
                                item.typZE).nazev : '' }}</span>
                          </template>
                          <span>Způsob evidence parcely</span>
                        </v-tooltip>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span class="font-italic" v-bind="attrs" v-on="on"> {{ item.drupozKod ?
                              KnSeznam.KnSeznamDruhuPozemku.find(itemc =>
                                itemc.kod ==
                                item.drupozKod).nazev : '' }}</span>
                          </template>
                          <span>Druh pozemku</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on"> {{ item.zpuvypaKod ?
                              KnSeznam.KnSeznamVyuzitiPozemku.find(itemc =>
                                itemc.kod ==
                                item.zpuvypaKod).nazev : '' }}</span>
                          </template>
                          <span>Způsob využití</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>

                </table>

              </v-card>
            </v-col>
          </v-row>

          <!-- Nalezené stavby -->
          <v-row v-if="KnNajdiTyp == 'KnSta'" dense>
            <v-col cols="auto">
              <v-card flat class="mt-2 overflow-y-auto align-content-center d-flex" width="592" min-height="48"
                color="info">
                <table class="KnTableNalez ">

                  <tbody v-for="item in NalStas" :key="item.idStavby">

                    <tr>
                      <td>
                        <span class="success--text text-h6 font-weight-black">
                          {{ item.cisloDomovni }}
                        </span>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.idStavby" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnSta', item.idStavby, null, item)">
                              <v-icon>mdi-home</v-icon>
                            </v-btn>
                          </template>
                          <span>Informace o stavbě</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.parcelaIdentifikacni" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnPar', item.parcelaIdentifikacni.idParcely, null, item)">
                              <v-icon>mdi-card</v-icon>
                            </v-btn>
                          </template>
                          <span>Informace o parcele</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.lvId" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnLv', item.lvId)">
                              <v-icon>mdi-text-box</v-icon>
                            </v-btn>
                          </template>
                          <span>List vlastnictví</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.pravoStavby" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnPra', item.pravoStavby.idPravoStavby)">
                              <v-icon>mdi-toy-brick</v-icon>
                            </v-btn>
                          </template>
                          <span>Informace o právu stavby na parcele</span>
                        </v-tooltip>
                      </td>

                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{ (item.docasnaStavbaPopis == 'a') ? 'Ano' : 'Ne' }}</span>
                          </template>
                          <span>Dočasná stavba</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span class="font-italic" v-bind="attrs" v-on="on">
                              {{ (item.jeSoucastiPopis == 'R') ? 'Právo stavby' : 'Parcela' }}</span>
                          </template>
                          <span>Příznak součástí stavby</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span class="font-italic" v-bind="attrs" v-on="on"> {{ item.zpuVyKod ?
                              KnSeznam.KnSeznamVyuzitiStavby.find(itemc =>
                                itemc.kod ==
                                item.zpuVyKod).nazev : '' }}</span>
                          </template>
                          <span>Způsob využití</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </v-card>
            </v-col>
          </v-row>

          <!-- Nalezené práva stavby -->
          <v-row v-if="KnNajdiTyp == 'KnPra'" dense>
            <v-col cols="auto">
              <v-card flat class="mt-2 overflow-y-auto align-content-center d-flex" width="592" min-height="48"
                color="info">
                <table class="KnTableNalez ">

                  <tbody v-for="item in NalPras" :key="item.idPravoStavby">

                    <tr>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="success--text text-h6 font-weight-black"> {{
                              item.ucelPravaStavbyListPopis }}</span>
                          </template>
                          <span>Účel práva stavby</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.idPravoStavby" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnPra', item.idPravoStavby, null, item)">
                              <v-icon>mdi-toy-brick</v-icon>
                            </v-btn>
                          </template>
                          <span>Informace o právu stavby</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.lvId" icon v-bind="attrs" v-on="on" color="accent"
                              @click="ZmenaVybKn('KnLv', item.lvId)">
                              <v-icon>mdi-text-box</v-icon>
                            </v-btn>
                          </template>
                          <span>List vlastnictví</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{ item.datumKoncePlatnostiPopis }}</span>
                          </template>
                          <span>Datum konce platnosti</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </v-card>
            </v-col>
          </v-row>


        </v-container>


      </v-card>
    </v-dialog>

    <!-- Upozornění -->
    <v-dialog v-model="Alert_view" max-width="400">
      <v-alert class="pa-4 ma-0" type="error" dense icon="mdi-alert-circle-outline">{{ Alert_text }}
      </v-alert>
    </v-dialog>

    <!-- Pracuji -->
    <v-overlay :value="IsWorking">
      <v-progress-circular indeterminate color="accent" :size="100" :width="15" />
    </v-overlay>

  </v-container>
</template>

<script>
import ServiceKNM from "../services/ServiceKNM";


import { KnCis } from "./Kn/KnCis";

export default {
  mixins: [
    KnCis,
  ],


  props: {
    // Jméno komponenty
    CompName: { type: String },
    // Kategorie aplikace
    AppCategory: { type: String },
    // Adresa webové služby
    AppServiceurl: { type: Object },
    // Seznam  komponent
    CompList: { type: Array },
  },

  data() {
    return {
      // Vybraný výpis katastru
      KnVybTyp: null,
      // Vybrané hledání katastru
      KnNajdiTyp: null,

      // Měřítko výpisu
      VypisZoom: 100,
      // Černobílý výpis
      VypisLight: false,
      // Výška výpisu
      VypisHeight: 100,

      // Velikost okna
      windowSize: {
        x: 0,
        y: 0,
      },

      // Upozornění
      Alert_view: false,
      // Upozornění - text
      Alert_text: "",

      // Zobrazení dialogu hledání
      Dialog_NajdiKn_view: false,

      // Informace o vybraném objektu
      // Za každý druh jeden
      // Id, Ident (identifikace, když není ID, zatím se používá pouze u LV), Info (dlaší vlastností, zpravidla získáné vyhledáním)

      VybKnPar: { Id: null, Ident: {}, Info: null, Mbr: null, Vypis: null },
      VybKnSta: { Id: null, Ident: {}, Info: null, Mbr: null, Vypis: null },
      VybKnJed: { Id: null, Ident: {}, Info: null, Vypis: null },
      VybKnRiz: { Id: null, Ident: {}, Info: null, Vypis: null },
      VybKnPra: { Id: null, Ident: {}, Info: null, Vypis: null },
      VybKnLv: { Id: null, Ident: { katuzeKod: null, cisloLv: null }, Vypis: null },
      VybKnOs: { Id: null, Ident: {}, Info: null, Vypis: null },


      // Vybraná obec
      VybObec: null,
      // Vybrané Ku
      VybKu: null,
      // Vybrané část obce
      VybCastObce: null,

      // Hledaná parcela - číslo
      NajdiParCis: null,
      // Hledaná parcela - podlomení
      NajdiParPod: null,

      // Hledaná stavba - typStavbyKod
      NajdiStaTyp: null,
      // Hledaná stavba - cisloDomovni
      NajdiStaCis: null,

      // Hledané lv - číslo
      NajdiLvCis: null,




      // Nalezené parcely - seznam
      NalPars: [],
      // Nalezené stavby - seznam
      NalStas: [],
      // Nalezené práva stavby - seznam
      NalPras: [],


      // pracuji - hledání
      IsLoading_KnNajdi: false,

      // pracuji
      IsWorking: false,





    };
  },

  computed: {
    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },

    // Dotaz z mapy na parcelu - z globální proměnně
    MapQueryPar: function () {
      return this.$store.getters.GET_sMapQueryPar;
    },



  },

  watch: {
    // Dotaz z mapy na parcelu - změna globální proměnné
    MapQueryPar: function (value) {
      this.ZmenaMapQueryPar(value);
    },

    // při změně obce vynulovat vybrané ku a cást obce
    VybObec: function () {
      this.VybKu = null;
      this.VybCastObce = null;
    },



  },

  methods: {
    // Zavře tuto komponentu
    VybCompClose: function () {
      this.$store.commit("SET_sVybComp", {
        CompName: null,
        SlotName: this.CompList.find((item) => item.name == this.CompName).slot,
      });
    },

    // Změna okna
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };

      this.VypisHeight = window.innerHeight - 48 - 12 - 48 - 48 - 42 - 4;
    },


    // Změna vybraného kn objektu a načtení výpisu
    ZmenaVybKn(typ, id, ident, info) {

      this.Dialog_NajdiKn_view = false;

      switch (typ) {
        case 'KnPar':
          if (id != this.VybKnPar.Id) {
            // Změna
            this.VybKnPar = { Id: id, Ident: {}, Info: info, Mbr: null, Vypis: null }
            this.VybKnPar_NactiVypis();
          } else {
            // beze změny s výpisem
            if (this.VybKnPar.Vypis) {
              this.KnVybTyp = 'KnPar'
            } else {
              // beze změny s nenačteným výpisem
              this.VybKnPar_NactiVypis();
            }
          }
          break;

        case 'KnSta':
          if (id != this.VybKnSta.Id) {
            // Změna
            this.VybKnSta = { Id: id, Ident: {}, Info: info, Mbr: null, Vypis: null }
            this.VybKnSta_NactiVypis();
          } else {
            // beze změny s výpisem
            if (this.VybKnSta.Vypis) {
              this.KnVybTyp = 'KnSta'
            } else {
              // beze změny s nenačteným výpisem
              this.VybKnSta_NactiVypis();
            }
          }
          break;

        case 'KnJed':
          if (id != this.VybKnJed.Id) {
            // Změna
            this.VybKnJed = { Id: id, Ident: {}, Info: info, Vypis: null }
            this.VybKnJed_NactiVypis();
          } else {
            // beze změny s výpisem
            if (this.VybKnJed.Vypis) {
              this.KnVybTyp = 'KnJed'
            } else {
              // beze změny s nenačteným výpisem
              this.VybKnJed_NactiVypis();
            }
          }
          break;

        case 'KnRiz':
          if (id != this.VybKnRiz.Id) {
            // Změna
            this.VybKnRiz = { Id: id, Ident: {}, Info: info, Vypis: null }
            this.VybKnRiz_NactiVypis();
          } else {
            // beze změny s výpisem
            if (this.VybKnRiz.Vypis) {
              this.KnVybTyp = 'KnRiz'
            } else {
              // beze změny s nenačteným výpisem
              this.VybKnRiz_NactiVypis();
            }
          }
          break;

        case 'KnPra':
          if (id != this.VybKnPra.Id) {
            // Změna
            this.VybKnPra = { Id: id, Ident: {}, Info: info, Vypis: null }
            this.VybKnPra_NactiVypis();
          } else {
            // beze změny s výpisem
            if (this.VybKnPra.Vypis) {
              this.KnVybTyp = 'KnPra'
            } else {
              // beze změny s nenačteným výpisem
              this.VybKnPra_NactiVypis();
            }
          }
          break;

        case 'KnLv':
          if (id) {
            // Definováno id

            if (id != this.VybKnLv.Id) {
              // Změna
              this.VybKnLv = { Id: id, Ident: { katuzeKod: null, cisloLv: null }, Vypis: null }
              this.VybKnLv_NactiVypis();
            } else {
              // beze změny s výpisem
              if (this.VybKnLv.Vypis) {
                this.KnVybTyp = 'KnLv'
              } else {
                // beze změny s nenačteným výpisem
                this.VybKnLv_NactiVypis();
              }
            }

          } else if (ident.cisloLv) {
            // Definováno katuzeKod, cisloLv

            if (ident.cisloLv != this.VybKnLv.Ident.cisloLv || ident.katuzeKod != this.VybKnLv.Ident.katuzeKod) {
              // Změna
              this.VybKnLv = { Id: null, Ident: { katuzeKod: ident.katuzeKod, cisloLv: ident.cisloLv }, Vypis: null }
              this.VybKnLv_NactiVypis();
            } else {
              // beze změny s výpisem
              if (this.VybKnLv.Vypis) {
                this.KnVybTyp = 'KnLv'
              } else {
                // beze změny s nenačteným výpisem
                this.VybKnLv_NactiVypis();
              }
            }

          }

          break;

        case 'KnOs':
          if (id != this.VybKnOs.Id) {
            // Změna
            this.VybKnOs = { Id: id, Ident: {}, Info: info, Vypis: null }
            this.VybKnOs_NactiVypis();
          } else {
            // beze změny s výpisem
            if (this.VybKnOs.Vypis) {
              this.KnVybTyp = 'KnOs'
            } else {
              // beze změny s nenačteným výpisem
              this.VybKnOs_NactiVypis();
            }
          }
          break;

        default:

      }

    },


    // Najdi parcelu - vrátí seznam parcel
    NajdiPar: function () {
      if (this.VybKu == null) {
        this.NalPars = [];
        this.Alert_text = "Není zadáno katastrální území.";
        this.Alert_view = true;
      } else {
        if (this.NajdiParCis == null) {
          this.NalPars = [];
          this.Alert_text = "Není zadáno číslo parcely.";
          this.Alert_view = true;
        } else {
          // Poslat dotaz
          this.IsLoading_KnNajdi = true;
          if (this.NajdiParPod == "") {
            this.NajdiParPod = null;
          }
          ServiceKNM.ParNajdi(
            null,
            this.VybKu.kod,
            this.NajdiParCis,
            this.NajdiParPod
          )
            .then((response) => {
              if (response.data.Dokonceno) {
                this.NalPars = response.data.SeznamPar;
              } else {
                this.NalPars = [];
                this.Alert_text = response.data.Chyba;
                this.Alert_view = true;
              }

              this.IsLoading_KnNajdi = false;
            })
            .catch((error) => {
              console.log(error);
              this.NalPars = [];
              this.IsLoading_KnNajdi = false;
              this.Alert_text = "Chyba, pravděpodobně nejste přihlášeni.";
              this.Alert_view = true;
            })
            .then(function () {
              // always executed
            });
        }
      }
    },

    // Najdi stavbu - vrátí seznam parcel
    NajdiSta: function () {
      if (this.VybCastObce == null) {
        this.NalStas = [];
        this.Alert_text = "Není zadána část obce.";
        this.Alert_view = true;
      } else {
        if (this.NajdiStaCis == null) {
          this.NalStas = [];
          this.Alert_text = "Není zadáno číslo stavby.";
          this.Alert_view = true;
        } else {
          // Poslat dotaz
          this.IsLoading_KnNajdi = true;
          ServiceKNM.StaNajdi(
            null,
            this.VybCastObce.kod,
            this.NajdiStaTyp.kod,
            this.NajdiStaCis
          )
            .then((response) => {
              if (response.data.Dokonceno) {
                this.NalStas = response.data.SeznamSta;
              } else {
                this.NalStas = [];
                this.Alert_text = response.data.Chyba;
                this.Alert_view = true;
              }

              this.IsLoading_KnNajdi = false;
            })
            .catch((error) => {
              console.log(error);
              this.NalStas = [];
              this.IsLoading_KnNajdi = false;
              this.Alert_text = "Chyba, pravděpodobně nejste přihlášeni.";
              this.Alert_view = true;
            })
            .then(function () {
              // always executed
            });
        }
      }
    },


    // Najdi právo stavby - vrátí seznam 
    NajdiPra: function () {
      if (this.VybKu == null) {
        this.NalPras = [];
        this.Alert_text = "Není zadáno katastrální území.";
        this.Alert_view = true;
      } else {
        if (this.NajdiParCis == null) {
          this.NalPras = [];
          this.Alert_text = "Není zadáno číslo parcely.";
          this.Alert_view = true;
        } else {
          // Poslat dotaz
          this.IsLoading_KnNajdi = true;
          if (this.NajdiParPod == "") {
            this.NajdiParPod = null;
          }
          ServiceKNM.PraNajdi(
            null,
            null,
            this.VybKu.kod,
            this.NajdiParCis,
            this.NajdiParPod
          )
            .then((response) => {
              if (response.data.Dokonceno) {
                this.NalPras = response.data.SeznamPra;
              } else {
                this.NalPras = [];
                this.Alert_text = response.data.Chyba;
                this.Alert_view = true;
              }

              this.IsLoading_KnNajdi = false;
            })
            .catch((error) => {
              console.log(error);
              this.NalPras = [];
              this.IsLoading_KnNajdi = false;
              this.Alert_text = "Chyba, pravděpodobně nejste přihlášeni.";
              this.Alert_view = true;
            })
            .then(function () {
              // always executed
            });
        }
      }
    },


    // Najdi LV - resp. zobraz výpis podle čísla katastru a lv
    NajdiLv: function () {
      if (this.VybKu == null) {
        this.Alert_text = "Není zadáno katastrální území.";
        this.Alert_view = true;
      } else {
        if (this.NajdiLvCis == null) {
          this.Alert_text = "Není zadáno číslo Lv.";
          this.Alert_view = true;
        } else {
          this.ZmenaVybKn("KnLv", null, { katuzeKod: this.VybKu.kod, cisloLv: this.NajdiLvCis })
        }
      }
    },


    // Najdi vybranou parcelu podle ID
    // Ulož Info
    // Zobraz Lv
    // Když známe Info, pošle se požadavek na lv, parcela se nehledá
    VybKnPar_ZobrazLv: function () {

      if (this.VybKnPar.Info) {
        // Známe informace
        this.ZmenaVybKn('KnLv', this.VybKnPar.Info.lvId)
      } else {
        // neznáme ID

        // Poslat dotaz
        this.IsWorking = true;
        ServiceKNM.ParNajdi(
          this.VybKnPar.Id,
          null,
          null,
          null
        )
          .then((response) => {
            if (response.data.Dokonceno) {
              if (this.VybKnPar.Id == response.data.Zadani.Id) {
                this.VybKnPar.Info = response.data.SeznamPar[0]
                // Zobraz Lv
                this.ZmenaVybKn('KnLv', this.VybKnPar.Info.lvId)
              }
            } else {
              this.Alert_text = response.data.Chyba;
              this.Alert_view = true;
            }

            this.IsWorking = false;
          })
          .catch((error) => {
            console.log(error);
            this.IsWorking = false;
            this.Alert_text = "Chyba, pravděpodobně nejste přihlášeni.";
            this.Alert_view = true;
          })
          .then(function () {
            // always executed
          });

      }

    },


    // Najdi vybranou stavbu podle ID
    // Ulož Info
    // Zobraz Lv
    // Když známe Info, pošle se požadavek na lv, stavba se nehledá
    VybKnSta_ZobrazLv: function () {

      if (this.VybKnSta.Info) {
        // Známe informace
        this.ZmenaVybKn('KnLv', this.VybKnSta.Info.lvId)
      } else {
        // neznáme ID

        // Poslat dotaz
        this.IsWorking = true;
        ServiceKNM.StaNajdi(
          this.VybKnSta.Id,
          null,
          null,
          null
        )
          .then((response) => {
            if (response.data.Dokonceno) {
              if (this.VybKnSta.Id == response.data.Zadani.Id) {
                this.VybKnSta.Info = response.data.SeznamSta[0]
                // Zobraz Lv
                this.ZmenaVybKn('KnLv', this.VybKnSta.Info.lvId)
              }
            } else {
              this.Alert_text = response.data.Chyba;
              this.Alert_view = true;
            }

            this.IsWorking = false;
          })
          .catch((error) => {
            console.log(error);
            this.IsWorking = false;
            this.Alert_text = "Chyba, pravděpodobně nejste přihlášeni.";
            this.Alert_view = true;
          })
          .then(function () {
            // always executed
          });

      }

    },

    // Najdi vybrané právo stavby podle ID
    // Ulož Info
    // Zobraz Lv
    // Když známe Info, pošle se požadavek na lv, právo stavby se nehledá
    VybKnPra_ZobrazLv: function () {

      if (this.VybKnPra.Info) {
        // Známe informace
        this.ZmenaVybKn('KnLv', this.VybKnPra.Info.lvId)
      } else {
        // neznáme ID

        // Poslat dotaz
        this.IsWorking = true;
        ServiceKNM.PraNajdi(
          this.VybKnPra.Id,
        )
          .then((response) => {
            if (response.data.Dokonceno) {
              if (this.VybKnPra.Id == response.data.Zadani.Id) {
                this.VybKnPra.Info = response.data.SeznamPra[0]
                // Zobraz Lv
                this.ZmenaVybKn('KnLv', this.VybKnPra.Info.lvId)
              }
            } else {
              this.Alert_text = response.data.Chyba;
              this.Alert_view = true;
            }
            this.IsWorking = false;
          })
          .catch((error) => {
            console.log(error);
            this.IsWorking = false;
            this.Alert_text = "Chyba, pravděpodobně nejste přihlášeni.";
            this.Alert_view = true;
          })
          .then(function () {
            // always executed
          });
      }
    },


    // WS - Výpis parcely
    VybKnPar_NactiVypis: function () {
      this.IsWorking = true;
      ServiceKNM.ParVypis(this.VybKnPar.Id)
        .then((response) => {
          if (response.data.Dokonceno) {
            if (this.VybKnPar.Id == response.data.Zadani.Id) {
              this.VybKnPar.Vypis = response.data.Vypis;
              this.KnVybTyp = 'KnPar';
            }
          } else {
            // this.VybKnPar = { Id: null, Ident: {}, Info: null, Mbr: null, Vypis: null };
            // this.KnVybTyp = null;
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
          this.IsWorking = false;
        })
        .catch((error) => {
          console.log(error);

          this.IsWorking = false;
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Výpis lv
    VybKnLv_NactiVypis: function () {
      this.IsWorking = true;
      ServiceKNM.LvVypis(this.VybKnLv.Id, this.VybKnLv.Ident.katuzeKod, this.VybKnLv.Ident.cisloLv)
        .then((response) => {
          if (response.data.Dokonceno) {
            if (this.VybKnLv.Id == response.data.Zadani.Id) {
              this.VybKnLv.Vypis = response.data.Vypis;
              this.KnVybTyp = 'KnLv';
            }
          } else {
            // this.VybKnLv = { Id: null, Ident: { katuzeKod: null, cisloLv: null }, Vypis: null };
            // this.KnVybTyp = null;
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
          this.IsWorking = false;
        })
        .catch((error) => {
          console.log(error);

          this.IsWorking = false;
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Výpis sta
    VybKnSta_NactiVypis: function () {
      this.IsWorking = true;
      ServiceKNM.StaVypis(this.VybKnSta.Id)
        .then((response) => {
          if (response.data.Dokonceno) {
            if (this.VybKnSta.Id == response.data.Zadani.Id) {
              this.VybKnSta.Vypis = response.data.Vypis;
              this.KnVybTyp = 'KnSta';
            }
          } else {
            // this.VybKnSta = { Id: null, Ident: {}, Info: null, Mbr: null, Vypis: null };
            // this.KnVybTyp = null;
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
          this.IsWorking = false;
        })
        .catch((error) => {
          console.log(error);

          this.IsWorking = false;
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Výpis pra
    VybKnPra_NactiVypis: function () {
      this.IsWorking = true;
      ServiceKNM.PraVypis(this.VybKnPra.Id)
        .then((response) => {
          if (response.data.Dokonceno) {
            if (this.VybKnPra.Id == response.data.Zadani.Id) {
              this.VybKnPra.Vypis = response.data.Vypis;
              this.KnVybTyp = 'KnPra';
            }
          } else {
            // this.VybKnPra = { Id: null, Ident: {}, Info: null, Vypis: null };
            // this.KnVybTyp = null;
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
          this.IsWorking = false;
        })
        .catch((error) => {
          console.log(error);

          this.IsWorking = false;
        })
        .then(function () {
          // always executed
        });
    },


    // Výběr parcely z mapy
    ZmenaMapQueryPar: function (value) {
      if (
        typeof value !== "undefined" &&
        value != null &&
        JSON.stringify(value) !== "{}"
      ) {
        this.KnVybTyp = 'KnPar';
        this.IsWorking = true;

        // WS - id parcely podle souřadnice (v proměnné MapQueryPar)
        ServiceKNM.PointPar(3857, value.Bbox.Xmin, value.Bbox.Ymin, false)
          .then((response) => {
            if (response.data.Dokonceno) {
              this.ZmenaVybKn('KnPar', response.data.JkDefBod.Id, null, null)
            } else {
              this.Alert_text = response.data.Chyba;
              this.Alert_view = true;
            }
            this.IsWorking = false;
          })
          .catch((error) => {
            console.log(error);

            this.IsWorking = false;
          })
          .then(function () {
            // always executed
          });
      }
    },



    // zoom na parcelu
    VybKnPar_MapZoom: function () {
      this.IsWorking = true;

      // console.log(this.VybKnPar);
      // console.log(!this.VybKnPar.Mbr);
      // console.log(this.VybKnPar.Mbr == {});

      if (!this.VybKnPar.Mbr) {
        // console.log("mbr ne");
        // mbr nemáme
        ServiceKNM.ParMbr(this.VybKnPar.Id, 3857)
          .then((response) => {
            if (response.data.Dokonceno) {
              if (this.VybKnPar.Id == response.data.Zadani.Id) {
                this.VybKnPar.Mbr = response.data.Mbr;
                // Přepnout na mapu
                this.VybComp = "Map";
                // Zoom na mapě
                this.$store.commit("SET_sMapMBR", {
                  epsg: "EPSG:3857",
                  xmin: response.data.Mbr.Xmin,
                  ymin: response.data.Mbr.Ymin,
                  xmax: response.data.Mbr.Xmax,
                  ymax: response.data.Mbr.Ymax,
                });
              }

            } else {
              this.Alert_text = response.data.Chyba;
              this.Alert_view = true;
            }
            this.IsWorking = false;
          })
          .catch((error) => {
            console.log(error);

            this.IsWorking = false;
          })
          .then(function () {
            // always executed
          });
      } else {
        // mbr máme
        this.VybComp = "Map";
        // Zoom na mapě
        this.$store.commit("SET_sMapMBR", {
          epsg: "EPSG:3857",
          xmin: this.VybKnPar.Mbr.Xmin,
          ymin: this.VybKnPar.Mbr.Ymin,
          xmax: this.VybKnPar.Mbr.Xmax,
          ymax: this.VybKnPar.Mbr.Ymax,
        });
        //console.log(this.VybKnPar);
      }
    },
  },

  mounted() {
    // Velikost okna
    this.onResize();

    // Nastavení služby
    ServiceKNM.Init(this.AppServiceurl.ServiceKNM);
    // ServiceKNJ.Init(this.AppServiceurl.ServiceKNJ);

    // Načtení číselníků
    this.KnSeznamInit()

    // Jestli už není požadován výpis parcely
    this.ZmenaMapQueryPar(this.MapQueryPar);
  },
};
</script>

<style>
.KnTableNalez {
  border-collapse: collapse;
}

.KnTableNalez td {
  padding: 0px 8px;
  word-wrap: break-word;
  white-space: nowrap;
}
</style>